<template>
<div class="opDashboard">
    <vx-card style="min-height:540px;">
    <vue-good-table mode="remote" 
    :pagination-options="{
        enabled: true,
    }" 
    :sort-options="{
        enabled: false,
    }"
    :totalRows="totalRecords"
    :rows="rows"
    :columns="columns"
    :isLoading.sync="isLoading"
    @on-column-filter="onColumnFilter"
    @on-page-change="onPageChange"
    @on-row-dblclick="navigate"
    styleClass="vgt-table condensed"/>
    </vx-card>
</div>
</template>

<script>
import flatPickr from "flatpickr";
// import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
 
    data() {

        return {
               components: {
             flatPickr
           },
            isLoading: false,
            columns: [{
                    label: 'Doctor Name',
                    field: 'doctorName',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                   width:'150px'

                },
                {
                    label: 'Appointment Date',
                    field: 'appointmentDate',
                     type: 'date',
                    dateInputFormat: 'dd/mm/yyyy', 
                    dateOutputFormat: "dd-mm-yyyy",
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: 'dd-mm-yyyy', // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                    width: '150px',
                      thClass: 'text-center',
                      tdClass: 'text-center'
                },
                {
                    label: 'Appointment Time',
                    field: 'appointmentTime',
                     filterOptions: {
                        enabled: true, 
                        placeholder: " ", 
                        trigger: '', 
                   },
                   width:'150px',
                    thClass: 'text-center',
                      tdClass: 'text-center'
                },
                {
                    label: 'Token No',
                    field: 'tokenNo',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                    tdClass: 'text-center',
                     thClass: 'text-center'
                },
                 {
                    label: 'Phone No',
                    field: 'phoneNo',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                },
                
                {
                    label: 'Name',
                    field: 'patientName',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Age',
                    field: 'patientAge',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Status',
                    field: 'status',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                    tdClass: this.tdClassFunc,
                },

                /*{
                    label: 'Booking ID',
                    field: 'bookingid',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Entry Time',
                    field: 'entryTime',
                     type: 'date',
                    dateInputFormat: 'dd/mm/yyyy', 
                    dateOutputFormat: "dd-mm-yyyy",
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: 'dd-mm-yyyy',  // placeholder for filter input
                        trigger: '', //only trigger on enter not on keyup 
                   },
                    thClass: 'text-center',
                      tdClass: 'text-center'
                },*/


            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                companyId:this.$session.get('companyId'),
                filter: {},
                currentPage: 1,
                limit: 10

            },
        }
        },

            mounted() {
                  let inputs = [
            'input[placeholder="dd-mm-yyyy"]'
            ];
            inputs.forEach(function(input) {
            flatPickr(input, {
                // dateFormat: "m-d-Y",
                dateFormat: "d-m-Y",
                // mode: "range",
                allowInput: true
            });
            });
            this.loadItems();
            },

            methods: {
                tdClassFunc(row) {
                    if (row.status =='OP') {
                    return 'red-class';
                    }else{
                        return 'green-class';
                    }
                   
                },
                updateParams(newProps) {
                    this.serverParams = Object.assign({}, this.serverParams, newProps);
                },
                onPageChange(params) {
                    console.log(params);
                    this.updateParams({
                        currentPage: params.currentPage
                    });
                    this.loadItems();
                },
                onColumnFilter(params) {
                    this.updateParams({
                        filter:params.columnFilters
                    });
                    this.loadItems();
                },
                loadItems() {
                 
                    this.$http.post(
                        "v2/getdashboarddetails",
                        JSON.stringify(this.serverParams), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(response => {
                       
                        this.totalRecords =response.data.recordsTotal ;
                        this.rows = response.data.data;

                    });

                },

                navigate(item,index,event) {
                    
                    if (item.row.status == 'Booked') {
              
                        var request = {
                            companyId: this.$session.get('companyId'),
                            phoneNo: item.row.phoneNo
                        };
                this.$http.post(
                        "checkpatientRegister",
                        JSON.stringify(request), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    )
                    .then(response => {
                        this.$router.push({
                            path: "patientRegistration",
                            query: {
                                patientId: response.data.data.patientId,
                                tokenNo: item.row.tokenId,
                                phoneNo: item.row.phoneNo
                            }
                        });
                    }).catch(error => {
                        
                        this.$router.push({
                            path: "patientRegistration",
                            query: {
                                tokenNo: item.row.tokenId,
                                phoneNo: item.row.phoneNo,
                                patientName: item.row.patientName,
                                patientAge: item.row.patientAge
                            }
                        });
                    })
                          }
                }

            }
        }
</script>

<style>
.vgt-table thead th {
    background: white;
}
.vgt-wrap__footer{
  background: white;
}
table.vgt-table{
    font-size:12px;
    border: none;
}
.vgt-right-align {
    text-align: left;
}
/* .vgt-responsive {
    min-height:488px;
} */
.vgt-table.condensed tr{
    height: 56px;
}
.vgt-table.condensed td{
    padding-top: 19px;
}
.vgt-input{
    border: none;
}
.vgt-wrap__footer{
border: none;
}
 .flatpickr-calendar{ 
    
     width: 305.625px !important; 
     /* height: 300.627px !important;  */
} 
.flatpickr-rContainer {
    width: 95% !important;
}
.dayContainer{
      min-width: 86% !important;
      max-width: 86% !important;
}
/* .flatpickr-current-month{
    width: 66%;
} */
/* .flatpickr-calendar .flatpickr-next-month{
    right: 0 !important;
} */
/*.flatpickr-months{
    width:100%;
} */ 

.flatpickr-monthDropdown-months{
    margin-left: -18%;
}
.flatpickr-monthDropdown-month{
    font-size: 11 !important;
}
.flatpickr-next-month{
    right: 57px !important;
}
.flatpickr-months{
    width: 97%;
}
.red-class{
    color:red !important;
}
.green-class{
    color:green !important;
}
</style>
